/**
 * Infinity Collectables - Load More
 * assets/ic-load-more.js
 *
 * Adds "Load more" behaviour beneath the numbered pagination on collection
 * and search pages. Clicking the button fetches the next page, appends its
 * product cards to the existing #product-grid, and advances the button to the
 * page after that. Numbered pagination links continue to work as normal
 * (they jump to a page with a full reload). Appended <product-form> custom
 * elements upgrade automatically, so Add to Cart keeps working.
 *
 * Bound once via event delegation; guarded so duplicate includes are harmless.
 */
(function () {
  'use strict';

  if (window.__icLoadMoreBound) return;
  window.__icLoadMoreBound = true;

  var GRID_ID = 'product-grid';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ic-load-more');
    if (!btn) return;
    e.preventDefault();

    var url = btn.getAttribute('data-next-url');
    var grid = document.getElementById(GRID_ID);
    if (!url || !grid) return;

    var originalText = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = 'Loading...';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById(GRID_ID);

        if (newGrid) {
          var items = newGrid.querySelectorAll('.grid__item');
          var frag = document.createDocumentFragment();
          items.forEach(function (li) {
            frag.appendChild(document.importNode(li, true));
          });
          grid.appendChild(frag);
        }

        // Advance the button to the following page, or remove it when done.
        var nextBtn = doc.querySelector('.ic-load-more');
        var nextUrl = nextBtn ? nextBtn.getAttribute('data-next-url') : null;

        if (nextUrl) {
          btn.setAttribute('data-next-url', nextUrl);
          btn.disabled = false;
          btn.textContent = originalText;
        } else {
          var wrap = btn.closest('.ic-load-more-wrap') || btn;
          wrap.remove();
        }
      })
      .catch(function (err) {
        console.error('Load more failed:', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
})();
